var map = {
	"./home/home.vue": [
		"77b8",
		"chunk-2d0d7bec"
	],
	"./index.vue": [
		"1e4b"
	],
	"./sit/sit.vue": [
		"e81d",
		"chunk-0e13ce90"
	],
	"./tc/telearn.vue": [
		"f081",
		"chunk-11846f75"
	],
	"./te/learn.vue": [
		"6cfb",
		"chunk-31fdee89"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;